﻿(function ($, document, undefined) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isDesktopSafari = false;
    if (/Safari/i.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor) && !/Mobi|Android/i.test(navigator.userAgent)) {
        isDesktopSafari = true;
    }

    window.DisableLoading = function (button) {
        var $btn = $(button);
        if (!$btn.hasClass('disabled')) {
            return;
        }
        $btn
            .removeClass('disabled')
            .removeClass('running')
            .prop("disabled", false)
            .unwrap()
        ;

        $btn
            .removeAttr('disabled')
            .removeProp('disabled')
        ;

        if (!isIE11 && !isDesktopSafari) {
            var $label = $btn.find('[data-loading-button-label]');
            $label.stop().fadeIn();
            $label.html($label.data('loading-original-label'))
            ;
        } else {
            $btn.html($btn.data('loading-original-label'));
        }
    };

    window.EnableLoading = function (button) {
        var $btn = $(button);

        var buttonClasses = "";

        if ($btn.hasClass('expand')) {
            buttonClasses += ' expand'
        }

        $btn
            .addClass('disabled')
            .prop('disabled', 'disabled')
            .attr('disabled', 'disabled')
            .wrap('<div class="button-cursor-not-allowed' + buttonClasses + '"></div>');

        var attr = $btn.attr('data-loading-external');

        if (typeof attr !== typeof undefined && attr !== false) {
            $(attr).each(function (i, n) {
                var buttonClasses = "";

                if ($(n).hasClass('expand')) {
                    buttonClasses += ' expand'
                }

                $(n).addClass('disabled')
                    .prop('disabled', 'disabled')
                    .attr('disabled', 'disabled')
                    .wrap('<div class="button-cursor-not-allowed' + buttonClasses + '"></div>')
                    ;
            });
        }

        if (!isIE11 && !isDesktopSafari) {
            $btn
                .find('[data-loading-button-label]')
                .fadeOut(function () {
                    $(this)
                        .data('loading-original-label', $(this).html())
                        .text($btn.data('loading'))
                        .fadeIn(function () {

                            setTimeout(function () {
                                if ($btn.hasClass('disabled')) {
                                    $btn.addClass('running');
                                }
                            }, 50);
                        });
                });
        } else {
            $btn
                .data('loading-original-label', $btn.html())
                .text($btn.data('loading'));
        }
    };

    $(document).ready(function () {
        if (!isIE11) {
            $('[data-loading]').each(function (n, i) {
                var $btn = $(this);
                var content = $btn.html();
                if (typeof $btn.attr('data-no-spinner') === 'undefined' || $btn.attr('data-no-spinner') === false) {
                    $btn
                        .addClass('ld-ext-right')
                        .html('<span data-loading-button-label>' + content + '</span>')
                        .append('<div class="ld ld-loader" style="background-image:url(/CMSGlobalFiles/Img/Icons/loading-spinner.gif);"></div>')
                    ;
                }
            });
        }

        $(document).on('click', 'a[data-loading][disabled]', function (e) {
            e.preventDefault();
            window.console.log('Button can only be clicked once');
        });

        $(document).on('click', '[data-loading]:not([data-loading-delay])', function (e) {
            if (typeof Page_ClientValidate == 'function') {
                var validationGroup = $(this).data('validation-group');
                Page_ClientValidate(validationGroup);
                if (!Page_IsValid) {
                    return;
                }
            }

            window.EnableLoading(this);
        });
    });
})(jQuery, document);
